/****************************************
	Alert
*****************************************/
;(function ($) {
	'use strict';
	var shared = {
			'debounce': function (callback, delay, immediate) {
				return this.throttle(callback, delay, undefined, !!immediate);
			},
			'focusable': function (element, isTabIndexNotNaN) {
				var nodeName = element.nodeName.toLowerCase();
				return (/input|select|textarea|button|object/.test(nodeName) ? !element.disabled : 'a' === nodeName ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) && this.visible(element);
			},
			'getRandomNumber': function (min, max) {
				if (!isNaN(min) && !isNaN(max)) {
					return Math.floor((Math.random() * (1 + max - min)) + min);
				}
				return Date.now().toString() + Math.floor((Math.random() * 1000) + 1);
			},
			'isValidCallback': function (callback) {
				return callback && $.isFunction(callback);
			},
			'lang': (function () {
				var langAttr = $('html').attr('lang') || $('[lang]').first().attr('lang');
				return langAttr ? langAttr.toLowerCase() : 'en';
			}()),
			'localize': function (langSet, key) {
				if (langSet[this.lang] && langSet[this.lang][key]) {
					return langSet[this.lang][key];
				}
				if (langSet[this.lang.substring(0, 2)] && langSet[this.lang.substring(0, 2)][key]) {
					return langSet[this.lang.substring(0, 2)][key];
				}
				return langSet.en[key] || '';
			},
			'tabbable': function (element) {
				var tabIndex = $.attr(element, 'tabindex'),
					isTabIndexNaN = isNaN(tabIndex);
				return (isTabIndexNaN || tabIndex >= 0) && this.focusable(element, !isTabIndexNaN);
			},
			'throttle': function (callback, delay, noTrail, immediate) {
				var timeout,
					previous = 0,
					result = function () {
						var self = this,
							elapsed = Date.now() - previous,
							args = arguments,
							timeoutCallback,
							timeoutDelay;
						function reset() {
							timeout = undefined;
						}
						function execute() {
							previous = Date.now();
							callback.apply(self, args);
						}
						if (immediate && !timeout) {
							execute();
						}
						if (timeout) {
							clearTimeout(timeout);
						}
						if (immediate === undefined && elapsed > delay) {
							execute();
						} else if (noTrail !== true) {
							timeoutCallback = immediate ? reset : execute;
							timeoutDelay = immediate === undefined ? delay - elapsed : delay;
							timeout = setTimeout(timeoutCallback, timeoutDelay);
						}
					};
				return result;
			},
			'timer': function (callback, delay) {
				var timerId,
					remaining = delay,
					start,
					state = 'stopped',
					obj = {
						'pause': function () {
							if (state === 'play') {
								clearTimeout(timerId);
								remaining -= new Date() - start;
								state = 'pause';
							}
						},
						'stop': function () {
							if (state !== 'stopped') {
								clearTimeout(timerId);
								remaining = delay;
								state = 'stopped';
							}
						},
						'play': function () {
							if (state !== 'play') {
								start = new Date();
								clearTimeout(timerId);
								timerId = setTimeout(function () {
									callback();
									remaining = delay;
								}, remaining);
							}
							state = 'play';
						}
					};
				obj.play();
				return obj;
			},
			'visible': function (element) {
				return $(element).is(':visible') &&
					!$(element).parents().andSelf().filter(function () {
						return $.css(this, 'visibility') === 'hidden';
					}).length;
			},
			'warn': function (msg, useAlert) {
				if (window.console) {
					console.warn(msg);
					if (useAlert && /ancestry(?:stage|dev)/.test(window.location.hostname)) {
						alert(msg);
					}
				}
			}
		},
		alert = {
			'create': function ($element, options) {
				var instance = $element.data('alertInstance');
				if (instance) {
					instance.destroy();
				}
				instance = Object.create(this.proto);
				instance.$element = $element;
				instance.config = $.extend({}, this.staticProperties.defaults, instance._getOptionsByClass(), options);
				instance.uniqueId = ($element.attr('id') || shared.getRandomNumber());
				instance.shouldAnimate = instance.config.animation === true && (($('body').find(instance.$element).length && !shared.visible($element[0])) || !instance.config.open);
				instance.hasFocusableChildren = instance._hasTabbableElements();
				instance.$element.attr(instance._getAttributes());
				instance._initClasses();
				instance.isOpen = false;
				instance.bottomMargin = instance._getBottomMargin();
				if (instance.config.display === 'notification') {
					instance.shouldAnimate = instance.config.animation !== false;
					instance._addOrRemoveNotification();
					instance.config.closeable = true;
					instance.config.removable = true;
				} else if (instance.config.display === 'overlay') {
					instance.center();
					$(window).on('resize.alert.' + instance.uniqueId + ' orientationchange.alert.' + instance.uniqueId, shared.debounce(function () {
						instance.center();
					}, 100));
					instance.config.closeable = true;
				}
				if (instance.config.open) {
					instance.open();
				}
				if (instance.config.closeable) {
					instance._createCloseButton();
				}
				instance.$element.data('alertInstance', instance);
				return instance;
			},
			'proto': {
				'_addOrRemoveNotification': function () {
					if (!$('#alertNotifications').length) {
						$('<div id="alertNotifications" class="alertNotifications" aria-live="polite"></div>').appendTo('body');
					}
					if (!this.$element.parents('#alertNotifications').length) {
						this.$element.prependTo('#alertNotifications');
					}
				},
				'center': function () {
					var width;
					if (this.config.display !== 'overlay') {
						return;
					}
					this.$element.css({
						'display': 'inline-block',
						'position': 'relative',
						'width': 'auto'
					});
					width = Math.ceil(this.$element[0].getBoundingClientRect().width);
					this.$element.css({
						'display': '',
						'margin-left': '-' + Math.floor(width / 2) + 'px',
						'position': '',
						'width': width
					});
				},
				'close': function () {
					var marginShouldAnimate,
						self = this;
					if (!this.isOpen) {
						return;
					}
					this.$element.trigger('closing.alert');
					if (this.config.animation) {
						marginShouldAnimate = this.$element.hasClass('alertSitewide') || this.$element.is(':first-child');
						this.$element
							.addClass('alertHiding')
							.css('margin-bottom', this.bottomMargin - this.$element.outerHeight(marginShouldAnimate));
						setTimeout(function () {
							self._closed();
						}, 410);
					} else {
						this._closed();
					}
				},
				'_closed': function () {
					this.$element
						.addClass('alertHidden')
						.css('margin-bottom', '');
					if (shared.isValidCallback(this.config.onClose)) {
						this.config.onClose.apply(this.$element, [this.$element]);
					}
					if (this.durationTimer) {
						this.durationTimer.stop();
					}
					this.isOpen = false;
					this.shouldAnimate = this.config.animation;
					this.$element.trigger('closed.alert');
					if (this.config.removable) {
						this.destroy();
					}
				},
				'_createCloseButton': function () {
					var $closeBtn = this.$element.find('.alertCloseBtn'),
						self = this;
					if ($closeBtn.length) {
						$closeBtn
							.addClass('closeBtn')
							.empty();
					} else {
						$closeBtn = $('<button class="closeBtn alertCloseBtn" type="button" title="' + shared.localize(alert.staticProperties.langSets, 'closeBtn') + '"></button>');
						this.$element.append($closeBtn);
					}
					this.$element.addClass('alertCloseable');
					$closeBtn.on('click.alert', function () {
						self.close();
					});
				},
				'destroy': function () {
					$(window).off('.alert.' + this.uniqueId);
					if (this.config.removable) {
						this.$element.remove();
					} else {
						this.$element
							.off('.alert')
							.removeData('alertInstance')
							.removeClass('alertCloseable alertInfo alertNoIcon alertNotification alertOverlay alertSection alertSitewide alertSlim alertSuccess')
							.find('.closeBtn')
							.remove();
					}
				},
				'_getAttributes': function () {
					var attr = {
						'role': this.$element.attr('role'),
						'aria-label': this.$element.attr('aria-label')
					};
					if (!this.$element.attr('role')) {
						if (this.hasFocusableChildren) {
							attr.role = 'alertdialog';
							attr.tabindex = this.$element.attr('tabindex') || '-1';
						} else if (this.config.type === 'warning' || this.config.type === 'success') {
							attr.role = 'alert';
						} else {
							attr.role = 'status';
						}
					}
					if (!this.$element.attr('aria-label')) {
						attr['aria-label'] = this.$element.contents().first().text();
					}
					return attr;
				},
				'_getBottomMargin': function () {
					/* Store margin-bottom (for animation) */
					var bottomMargin = parseInt(this.$element.css('margin-bottom'), 10);
					return isNaN(bottomMargin) ? 0 : bottomMargin;
				},
				'_getOptionsByClass': function () {
					var options = {};
					if (this.$element.hasClass('alertSuccess')) {
						options.type = 'success';
					} else if (this.$element.hasClass('alertInfo') || this.$element.hasClass('alertNote')) {
						options.type = 'info';
					}
					if (this.$element.hasClass('alertSitewide')) {
						options.display = 'sitewide';
					} else if (this.$element.hasClass('alertNotification')) {
						options.display = 'notification';
					} else if (this.$element.hasClass('alertSection')) {
						options.display = 'section';
					} else if (this.$element.hasClass('alertOverlay')) {
						options.display = 'overlay';
					}
					if (this.$element.hasClass('alertSlim')) {
						options.size = 'slim';
					}
					if (this.$element.hasClass('alertNoIcon')) {
						options.noIcon = true;
					}
					if (this.$element.hasClass('alertHidden')) {
						options.open = false;
					}
					if (this.$element.hasClass('alertCloseable')) {
						options.closeable = true;
					}
					return options;
				},
				'_hasTabbableElements': function () {
					var $elem = $(this.$element),
						tabElems = 0;
					$elem.children().each(function () {
						if (shared.tabbable(this) && !$(this).hasClass('alertCloseBtn')) {
							tabElems += 1;
						}
					});
					return tabElems > 0;
				},
				'_initClasses': function () {
					this.$element
						.addClass('alert')
						.removeClass('alertCloseable alertInfo alertNoIcon alertNotification alertOverlay alertSection alertSitewide alertSlim alertSuccess');
					switch (this.config.display) {
						case 'notification':
							this.$element.addClass('alertNotification');
							break;
						case 'overlay':
							this.$element.addClass('alertOverlay');
							break;
						case 'section':
							this.$element.addClass('alertSection');
							break;
						case 'sitewide':
							this.$element.addClass('alertSitewide');
							break;
					}
					switch (this.config.type) {
						case 'success':
							this.$element.addClass('alertSuccess');
							break;
						case 'info':
							this.$element.addClass('alertInfo');
							break;
						case 'note':
							this.$element.addClass('alertInfo');
							break;
					}
					if (this.config.closeable === true) {
						this.$element.addClass('alertCloseable');
					}
					if (this.config.noIcon === true) {
						this.$element.addClass('alertNoIcon');
					}
					if (this.config.size === 'slim') {
						this.$element.addClass('alertSlim');
					}
					if (!this.config.open) {
						this.$element.addClass('alertHidden alertHiding');
					} else if (this.config.open) {
						this.$element.removeClass('alertHidden alertHiding');
					}
				},
				'open': function () {
					var marginToHideAlert,
						self = this;
					if (this.isOpen) {
						return; /* don't run the method if the alert is already open */
					}
					this.$element.trigger('opening.alert');
					if (this.shouldAnimate) {
						marginToHideAlert = this.$element.removeClass('alertHidden').outerHeight(false);
						this.$element
							.addClass('alertNoTransition')
							.css('margin-bottom', this.bottomMargin - marginToHideAlert);
						setTimeout(function () {
							self.$element
								.removeClass('alertNoTransition alertHiding')
								.css('margin-bottom', '');
						}, 10);
						setTimeout(function () {
							self._opened();
						}, 410);
					} else {
						self.$element.removeClass('alertHidden alertHiding');
						this._opened();
					}
				},
				'_opened': function () {
					var self = this;
					if (this.hasFocusableChildren) {
						this.$element.focus();
					}
					if (this.config.duration > 0) {
						this.durationTimer = shared.timer(function () {
							self.close();
						}, this.config.duration);
						this.$element
							.on('mouseenter.alert', function () {
								self.durationTimer.pause();
							})
							.on('mouseleave.alert', function () {
								self.durationTimer.play();
							});
					}
					if (shared.isValidCallback(this.config.onOpen)) {
						this.config.onOpen.apply(this.$element, [this.$element]);
					}
					this.$element.trigger('opened.alert');
					this.isOpen = true;
				}
			},
			'staticProperties': {
				'defaults': {
					'animation': true, /* Whether or not to animate in the alert or not */
					'closeable': false, /* Set true to make the alert closeable */
					'display': 'inline', /* 'inline' (default) | 'sitewide' | 'section' | 'overlay' | 'notification' */
					'duration': -1, /* Milliseconds before the alert automatically closes */
					'removable': false, /* Set true to remove alert from DOM when closed */
					'noIcon': false,
					'onClose': false, /* function($alertElement){} */
					'onOpen': false, /* function($alertElement){} */
					'open': true, /* Set false to hide on page load */
					'type': 'warning' /* 'warning' (default) | success' | 'info' */
				},
				'langSets': {
					'de': {
						'closeBtn': 'Schlie&#223;en'
					},
					'en': {
						'closeBtn': 'Close'
					},
					'es': {
						'closeBtn': 'Cerrar'
					},
					'fr': {
						'closeBtn': 'Fermer'
					},
					'it': {
						'closeBtn': 'Chiudi'
					},
					'sv': {
						'closeBtn': 'St&#228;ng'
					}
				}
			}
		},
		version = 2,
		doubleIncluded = !!$.alert;
	if (doubleIncluded) {
		if ($.alert.version === version) {
			shared.warn('ERROR: You are including alert.js multiple times');
			return;
		} else {
			shared.warn('ERROR: You are including multiple versions of alert.js');
			if ($.alert.version > version) {
				return;
			}
		}
	}
	$.fn.alert = function (options) {
		var args = arguments,
			isMethodCall = typeof options === 'string', /* If options is a string, we assume it refers to a method. */
			returnValue = this;
		this.each(function () {
			var self = $(this),
				instance = self.data('alertInstance'),
				methodValue;
			if (isMethodCall) {
				if (!instance) {
					shared.warn('Cannot call methods on alert prior to initialization; attempted to call method "' + options + '".');
					return false;
				}
				if (!$.isFunction(instance[options]) || options.indexOf('_') === 0) {
					shared.warn('No such method "' + options + '" for alert.');
					return false;
				}
				methodValue = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
				if (methodValue !== instance && methodValue !== undefined) {
					returnValue = methodValue && methodValue.jquery ? returnValue.pushStack(methodValue.get()) : methodValue;
					return false;
				}
			} else {
				alert.create(self, options);
			}
		});
		return returnValue;
	};
	$.alert = {
		'getTest': function () {
			return $.extend({}, alert);
		},
		'version': version
	};
	if (!doubleIncluded) {
		/* auto-instantiate if necessary */
		$(function () {
			$('.alert:not([data-auto-instantiate="off"])').alert();
		});
	}
}(jQuery));